import { normalize } from './normalize';

import { createGlobalStyle } from 'styled-components';

import { globalStyleCommon } from './globalstyle';

export const GlobalStyleWrap = createGlobalStyle`
  ${normalize}
  ${globalStyleCommon}
`;
